module.exports = __webpack_public_path__ + "img/close-4.d08a6817.svg";